export const getBrowserLocale = () => {
    const browserLocales = navigator.languages.length ? navigator.languages : [navigator.language];

    if (browserLocales.length === 0) return null;

    return browserLocales[0].trim();
}